module.exports = __webpack_public_path__ + "static/img/social video-病毒视频.bbd4f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/social video-病毒视频.png
// module id = Q6Z+
// module chunks = 1